import { createContext, useState, useContext } from 'react';

const UploadFlowContext = createContext();

export const UploadFlowProvider = ({ children }) => {
  const [stepsCompleted, setStepsCompleted] = useState({
    fmcsaUploaded: false,
  });

  return (
    <UploadFlowContext.Provider value={{ stepsCompleted, setStepsCompleted }}>
      {children}
    </UploadFlowContext.Provider>
  );
};

export const useUploadFlow = () => useContext(UploadFlowContext);
